import buildClientAPI from 'views/providers/clientAPI'
import store from 'shared/store'
import { isMarketplace, isSaeOnly } from 'shared/experiments/utils'

const MINICART_BADGE_SELECTORS = [
  '[data-clientside-hook~="Menubar__cart-badge"]',
  '[data-clientside-hook~="SmallHeader__cart-badge"]'
]

const MINICART_LINK_SELECTORS = [
  '[data-clientside-hook~="Menubar__cart-link"]',
  '[data-clientside-hook~="SmallHeader__cart-link"]'
]

/**
 * fail-save (for not found element) querying and setting of props
 *
 * @param {string} selector querySelector for the desired element
 * @param {object} props key/value pairs of props to set
 */
const selectAndSet = (selector, props) => {
  const element = document.querySelector(selector)
  if (element) {
    Object.keys(props).forEach(key => {
      element[key] = props[key]
    })
  }
}

export default async () => {
  const {
    pageProperties: { experiments }
  } = store.getPublicRuntimeConfig()

  if (isSaeOnly(experiments) || isMarketplace(experiments)) {
    const { cartService } = buildClientAPI()
    const miniCart = await cartService.fetchMiniCart()

    const cartQuantity = miniCart?.data?.entriesInCart || 0

    MINICART_BADGE_SELECTORS.forEach(selector => {
      selectAndSet(selector, { textContent: cartQuantity })
    })

    MINICART_LINK_SELECTORS.forEach(selector => {
      selectAndSet(selector, { href: '/nx/cart/' })
    })
  } else {
    MINICART_LINK_SELECTORS.forEach(selector => {
      selectAndSet(selector, { href: '/cart.htm' })
    })
  }
}
